import { DEFAULT_SCENARIO_ID, TemplateProviderContextType } from '#src/utils';
import { BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
import React, { createContext, useContext } from 'react';

import { getUppTemplateConfigPerScenarioId } from './UPPtemplateConfigPerScenario';

const DEFAULT_TEMPLATE_CONFIG =
  getUppTemplateConfigPerScenarioId(DEFAULT_SCENARIO_ID);

const DynamicTemplateProviderContext =
  createContext<TemplateProviderContextType>(DEFAULT_TEMPLATE_CONFIG);

export const useDynamicTemplate = (): TemplateProviderContextType =>
  useContext(DynamicTemplateProviderContext);

const ERROR_PROVIDER_NAME = 'DynamicTemplateProvider';

export const DynamicTemplateProvider = ({
  children,
  getTemplate,
}: {
  children: React.ReactNode;
  getTemplate: () => TemplateProviderContextType;
}) => {
  const templateConfig = getTemplate();
  return (
    <DynamicTemplateProviderContext.Provider value={templateConfig}>
      {children}
    </DynamicTemplateProviderContext.Provider>
  );
};

export const UPPDynamicTemplateProvider = ({
  children,
  scenarioId,
}: {
  children: React.ReactNode;
  scenarioId: string;
}) => {
  return (
    <BlockingErrorBoundary name={ERROR_PROVIDER_NAME}>
      <DynamicTemplateProvider
        getTemplate={() => getUppTemplateConfigPerScenarioId(scenarioId)}
      >
        {children}
      </DynamicTemplateProvider>
    </BlockingErrorBoundary>
  );
};

export { uppScenarioIds } from './UPPtemplateConfigPerScenario';
